import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Home from './components/Home';
import ProjectInquiry from './components/ProjectInquiry';
import Services from './components/Services';
import About from './components/About';
import PrivacyPolicy from './components/PrivacyPolicy';
import TermsOfService from './components/TermsOfService';
import Navigation from './components/Navigation';
import LanguageSwitcher from './components/LanguageSwitcher';
import { StickyFooter as Footer } from './components/ui/sticky-footer';
import { HeroSectionBasic } from './components/ui/demo';
import './App.css';
import './i18n';

// Component to scroll to top on route change
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    console.log('Route changed to:', pathname);
    window.scrollTo(0, 0);
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  }, [pathname]);

  return null;
}

function AppContent() {
  const { pathname } = useLocation();
  const isHeroDemoPage = pathname === '/hero-demo';

  return (
    <>
      <ScrollToTop />
      {!isHeroDemoPage && <Navigation />}
      <div className="app-content">
        {!isHeroDemoPage && <LanguageSwitcher />}
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/services" element={<Services />} />
          <Route path="/hero-demo" element={<HeroSectionBasic />} />
          <Route path="/start-project" element={<ProjectInquiry />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-of-service" element={<TermsOfService />} />
        </Routes>
      </div>
      {!isHeroDemoPage && <Footer />}
    </>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
